export default "__VITE_ASSET__de922516__"